module.exports = __webpack_public_path__ + "static/img/nav-bar-bg-kiko.986f9796.png";